// ABOUTME: POST /companies/:id/members/:employerId/invite: staff email a member a new set-password link.
// ABOUTME: Nothing in the member list changes, so nothing refetches; 404 (not a member) and 502 (Auth0 failed) toast an error.
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  ResendCompanyMemberInviteInput,
} from '../companies.types';

export const resendCompanyMemberInvite = (builder: CompanyBuilder) =>
  builder.mutation<void, ResendCompanyMemberInviteInput>({
    query: ({ companyId, employerId }) => ({
      url: `/companies/${companyId}/members/${employerId}/invite`,
      method: 'POST',
    }),
    transformResponse: (_response, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.MEMBER_INVITE_SENT
          : SuccessMessageEn.MEMBER_INVITE_SENT,
        true
      );
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[resendCompanyMemberInvite]',
        arg.lang === 'es'
          ? ErrorMessageEs.ResendMemberInvite
          : ErrorMessageEn.ResendMemberInvite,
        error,
        true
      );
      return error.data;
    },
  });
